export default __webpack_public_path__ + "static/media/OrgStructureImg.60d127de.svg";